<div class="footer d-flex align-items-center justify-content-center">
  Grid Edge Limited is registered in England and Wales (Company Number: 10129878).
</div>
